import { Api } from './api';

export const api = new Api();
